<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title">Fifty Days of Solitude</p>
<h2 class="centerN" style="margin-top:20px;">A Memoir</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?16730700